import React, { useState, useEffect } from "react"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Table, Row } from "reactstrap"
import { FaChevronLeft, FaChevronRight, FaFilter } from "react-icons/fa6"
import { Select, Switch } from "antd"
import { fetchData, FetchPostData } from "utils/Common_api_functions"
import viewImg from "../../assets/images/EditImg.jpg"
import Loader from "components/Loader/loader"
import moment from "moment"

const { Option } = Select

const PlanHistory = () => {
  const [userData, setUserData] = useState([])
  const [page, setPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  const [trainingPlans, setTrainingPlans] = useState([])
  const [packages, setPackages] = useState([])
  const [planType, setPlanType] = useState(null)
  const [subType, setSubType] = useState(null)
  const [subTypeOptions, setSubTypeOptions] = useState([])

  const [month, setMonth] = useState(null)
  const [year, setYear] = useState(null)

  const [loading, setloading] = useState(false)

  // Dynamic years
  const currentYear = new Date().getFullYear()
  const years = Array.from({ length: currentYear - 2023 }, (_, i) => 2024 + i)

  // Fetch all sub-options on mount
  const [allSubOptions, setAllSubOptions] = useState({})

  useEffect(() => {
    const fetchSubTypes = async () => {
      const APIdata = await fetchData(setloading, "training/plan")
      const Package = await fetchData(setloading, "pricing/plan")

      if (APIdata) {
        setTrainingPlans(APIdata?.plans)
      }
      if (Package) {
        setPackages(Package?.userPlans)
      }
    }
    fetchSubTypes()
  }, [])

  // Update subTypeOptions when planType changes
  useEffect(() => {
    if (!planType) {
      setSubTypeOptions([])
      setSubType(null)
      return
    }

    setSubTypeOptions(allSubOptions[planType] || [])
    setSubType(null)
  }, [planType, allSubOptions])

  // Fetch filtered user data whenever filters change
  useEffect(() => {
    const fetchData = async () => {
      const APIdata = await FetchPostData(setloading, "reports/plan/history", {
        type: planType,
        month,
        year,
      })
      if (APIdata?.data?.success) {
        const successfulPayments = APIdata.data.data
          .reverse()
          .filter(item => item.status === "succeeded")

        if (planType === "upgradePlan") {
          setUserData(
            successfulPayments.map(item => ({
              ...item,
              subscription:
                item.subscription === "Upgrade Plan"
                  ? "Global Upgrade"
                  : item.subscription,
              planType:
                item.planType === "Upgrade Plan"
                  ? "Global Upgrade"
                  : item.planType,
            }))
          )
        } else {
          setUserData(successfulPayments)
        }
      }
    }

    // Only fetch if planType is selected
    if (planType) fetchData()
  }, [planType, subType, month, year])

  const totalPages = Math.ceil(userData.length / itemsPerPage)

  const finalData = userData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  // Calculate total unique users
  const uniqueUsersCount = new Set(userData?.map(u => u?.user?._id)).size

  // Calculate total amount
  const totalAmount = userData?.reduce(
    (sum, u) => sum + Number(u.amount || 0),
    0
  )

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="Reports" breadcrumbItem="Plan History" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="mb-3">
                  <h4 className="text-black fw-bold mb-3">
                    Plan History Report
                  </h4>
                  <Row className="align-items-center justify-content-between">
                    <Col md="2">
                      <Card className="bg-light shadow-sm text-center rounded-4 mb-0">
                        <CardBody>
                          <h6>Total Users</h6>
                          <h4 className="mb-0">{uniqueUsersCount}</h4>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="2">
                      <Card className="bg-light shadow-sm text-center rounded-4 mb-0">
                        <CardBody>
                          <h6>Total Amount</h6>
                          <h4 className="mb-0">£ {totalAmount}</h4>
                        </CardBody>
                      </Card>
                    </Col>

                    <Col md="8">
                      <Row className="g-2 justify-content-end">
                        <Col md="2">
                          <Select
                            placeholder="Plan Type"
                            value={planType}
                            onChange={value => setPlanType(value)}
                            className="w-100"
                          >
                            <Option value="UserPlan">User Package</Option>
                            <Option value="TrainingPlan">Training Plan</Option>
                            <Option value="upgradePlan">Global Upgrade</Option>
                          </Select>
                        </Col>

                        <Col md="2">
                          <Select
                            placeholder="Month"
                            value={month}
                            onChange={setMonth}
                            className="w-100"
                          >
                            {[
                              "January",
                              "February",
                              "March",
                              "April",
                              "May",
                              "June",
                              "July",
                              "August",
                              "September",
                              "October",
                              "November",
                              "December",
                            ].map((m, i) => (
                              <Option key={i} value={i + 1}>
                                {m}
                              </Option>
                            ))}
                          </Select>
                        </Col>

                        <Col md="1">
                          <Select
                            placeholder="Year"
                            value={year}
                            onChange={setYear}
                            className="w-100"
                          >
                            {years.map(y => (
                              <Option key={y} value={y}>
                                {y}
                              </Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>

                {finalData?.length > 0 ? (
                  <>
                    <Table responsive bordered className="rounded-3">
                      <thead className="table-primary text-dark">
                        <tr>
                          <th>#</th>
                          <th>Athlete Name</th>
                          <th>Plan Name</th>
                          <th>Purchase Date</th>
                          <th>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {finalData.map((user, index) => (
                          <tr key={user.id}>
                            <td>{(page - 1) * itemsPerPage + index + 1}</td>
                            <td>{user?.user?.name}</td>

                            <td>{user?.subscription}</td>
                            <td>
                              {moment(user?.createdAt).format("DD-MM-YYYY")}
                            </td>
                            <td>£ {user.amount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="d-flex justify-content-between align-items-center my-2 px-2">
                      <p className="mb-0">
                        Showing {finalData.length} out of {userData.length}{" "}
                      </p>
                      <div className="d-flex flex-wrap">
                        <div
                          className="bd-number-pagination me-1"
                          onClick={() => changePage(page - 1)}
                          style={{ cursor: "pointer" }}
                        >
                          <FaChevronLeft />
                        </div>
                        {[...Array(totalPages)].map((_, i) => {
                          const pageIndex = i + 1
                          return (
                            <div
                              key={pageIndex}
                              className={`bd-number-pagination me-1 ${
                                page === pageIndex ? "activepage" : ""
                              }`}
                              onClick={() => changePage(pageIndex)}
                              style={{ cursor: "pointer" }}
                            >
                              {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                            </div>
                          )
                        })}
                        <div
                          className="bd-number-pagination"
                          onClick={() => changePage(page + 1)}
                          style={{ cursor: "pointer" }}
                        >
                          <FaChevronRight />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="card p-4 h-100">
                    <Row className="justify-content-center">
                      <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                        <img src={viewImg} alt="Image" width={400} />
                        <p className="text-purple fw-bold text-center lh-base">
                          📊🤵 Plan Report are Ready. <br />
                          Select Options to get Report. 📂📈
                        </p>
                      </div>
                    </Row>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PlanHistory
